var url = window.location.origin
export const BaseUrl =
    // url === "http://gayatriagroerp.gkmarket.in" ? "http://gayatriagroerpapi.gkmarket.in"

    url === "http://garden.nmmcsmartservices.com" ? "http://gardenapi.nmmcsmartservices.com" :
        url === "http://pcmc.cdatinfotech.com" ? "http://pcmcapi.cdatinfotech.com" :
            url === "http://new.nmmcsmartservices.com" ? "http://newapi.nmmcsmartservices.com" :
                url === "https://nmmcsmartservices.com" ? "https://api.nmmcsmartservices.com" :
                    url === "http://nmmcsmartservices.com" ? "http://api.nmmcsmartservices.com" :
                        url === "https://nmmcdaksha.cdat.work" ? "https://apinmmcdaksha.cdat.work" :
                            url === "https://nmmcdaksha.in" ? "https://api.nmmcdaksha.in" :

                                // "https://api.nmmcsmartservices.com"

                                "https://apinmmcdaksha.cdat.work"




